import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-5 mx-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5 text-size-14" }, [
  /*#__PURE__*/_createTextVNode("\n        過去のバージョンで登録済みのユーザーです。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("アカウント引き継いでご利用される場合は「次へ」をタップしてください。\n      ")
], -1)

import { onBeforeMount, ref } from "vue";
import { useRouter } from "vue-router";
import AppButton from "@/components/atoms/button/AppButton.vue";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import PhoneNumberInputGroup from "@/components/molecules/form/PhoneNumberInputGroup.vue";
import Header from "@/components/organisms/common/Header.vue";
import { authStore } from "@/store/auth";
import { useCustomRouter } from "@/utils/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'V1UserPhoneNumberAuth',
  setup(__props) {

const customRouter = useCustomRouter();
const router = useRouter();

const phoneNumber = ref("");

onBeforeMount(() => {
  phoneNumber.value = authStore.temporaryPhoneNumber as string;
});

async function nextStep() {
  authStore.changePhoneNumber(phoneNumber.value);
  await customRouter.pushIgnoreError({ name: "RegisterPhoneNumberAuth" });
}

function onClickBack() {
  router.back();
}

return (_ctx: any,_cache: any) => {
  const _component_ValidationField = _resolveComponent("ValidationField")!
  const _component_BForm = _resolveComponent("BForm")!
  const _component_CustomValidationObserver = _resolveComponent("CustomValidationObserver")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      電話番号認証\n    ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(),
      _createVNode(_component_CustomValidationObserver, {
        tag: "div",
        class: "w-100",
        initialValues: { phoneNumber: phoneNumber.value }
      }, {
        default: _withCtx(({ handleSubmit }) => [
          _createVNode(_component_BForm, {
            onSubmit: _withModifiers(($event: any) => (handleSubmit(nextStep)), ["stop","prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ValidationField, {
                label: "携帯電話番号",
                rules: "required|numeric|length:11",
                name: "phoneNumber"
              }, {
                default: _withCtx((validationState) => [
                  _createVNode(PhoneNumberInputGroup, {
                    modelValue: phoneNumber.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumber).value = $event)),
                    disabled: "",
                    placeholder: "携帯電話番号",
                    innerIconType: "phoneNumber",
                    class: "mb-3",
                    "validation-state": validationState
                  }, null, 8, ["modelValue", "validation-state"])
                ]),
                _: 1
              }),
              _createTextVNode(),
              _createVNode(AppButton, {
                block: "",
                rounded: "",
                onClick: ($event: any) => (handleSubmit(nextStep))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("\n            次へ\n          ")
                ], undefined, true),
                _: 2
              }, 1032, ["onClick"])
            ], undefined, true),
            _: 2
          }, 1032, ["onSubmit"])
        ]),
        _: 1
      }, 8, ["initialValues"])
    ])
  ]))
}
}

})